import React from 'react';
import SoundIconContainer from "./icons/sound/SoundIconContainer";
import PauseIconContainer from "./icons/pause/PauseIconContainer";
import FullScreenIconContainer from "./icons/fullscreen/FullScreenIconContainer";
import './Toolbox.scss';

const Toolbox = props => (
  <div className="toolbox">
    <SoundIconContainer/>
    <PauseIconContainer/>
    <FullScreenIconContainer/>
  </div>
);

export default Toolbox;
